import React, { useState } from "react";
import "../styles/Contact.css";
import Navbar from "../components/NavBar";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thank you! Your message has been sent.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-page">
      <Navbar />

      <div className="contact-container">
        <h1>Contact Us</h1>
        <p>We’d love to hear from you. Fill out the form below and we’ll get back to you soon!</p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            rows="6"
            required
          ></textarea>

          <button type="submit" className="submit-btn">Send Message</button>
        </form>

        <div className="contact-info">
          <h2>Our Contact Info</h2>
          <p>Email: amfcargotransporters@gmail.com</p>
          <p>Phone: +254 701 133430</p>
          <p>Address: Nairobi, Kenya</p>
        </div>
      </div>
    </div>
  );
}

export default Contact;